var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 1034 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 960)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M726 441h-428q-17 0 -29 -12t-12 -29v-132q0 -17 12 -29t29 -12v0h428q18 0 30 12t12 29v0v132v0v0q0 17 -12 29t-30 12v0v0v0v0zM718 273h-412v119h413zM873 555l-303 248q-12 10 -26.5 15.5t-31.5 5.5t-31.5 -5.5t-26.5 -15.5v0l-303 -248q-15 -12 -24 -30.5t-9 -39.5 v0v-1v0v-353q0 -24 17 -41t41 -17h673q24 0 41 17t17 41v0v353q0 21 -9 39.5t-25 31.5v0v0zM857 130v0v0q0 -4 -2.5 -6.5t-5.5 -2.5h-1v0v0h-673q-3 0 -6 3t-3 6v0v354q0 10 4.5 18.5t11.5 14.5v0l303 246q5 4 12 7t15 3q7 0 14 -3t13 -7v0l302 -248q8 -6 12 -14.5t4 -17.5 v-1v-352z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3b663dba.svg";
export { ForwardRef as ReactComponent };